<script setup lang="ts">
import type { NuxtLinkOptions } from "#app";

const props = defineProps<NuxtLinkOptions>();

const LinkWithTrailingSlash = defineNuxtLink({
  ...props,
  /**
   * It's a custom nuxt link which append trailing slash to each route.
   */
  trailingSlash: "append",
});
</script>

<template>
  <LinkWithTrailingSlash>
    <slot />
  </LinkWithTrailingSlash>
</template>
